export default __webpack_public_path__ + "static/media/product-detail-03.4a558818.jpg";